import { render, staticRenderFns } from "./animatedNumber.vue?vue&type=template&id=87f4cda8&"
import script from "./animatedNumber.vue?vue&type=script&lang=js&"
export * from "./animatedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports